<template>
  <div id="app" class="container-fluid">
    <!-- Header (UNCHANGED) -->
    <full_dental_head :visit_id="visit_id" />

    <!-- Main Content -->
    <div class="main-content">
      <div class="card history-card">
        <div class="history-header">
          <div>
            <h3>
              <i class="fas fa-history"></i>
              Dental History
            </h3>
            <small class="text-muted">
              Chronological dental records for this patient
            </small>
          </div>

          <button
            class="btn btn-outline-secondary"
            @click="openAddHistoryModal"
          >
            <i class="fas fa-plus"></i> Add Entry
          </button>
        </div>

        <div class="card-body history-body">
          <div class="history-timeline">
            <div class="history-item" v-for="item in history" :key="item.id">
              <div class="timeline-marker">
                <span class="date">{{ item.date }}</span>
              </div>

              <div class="timeline-content">
                <h5 class="history-title">
                  {{ item.title }}
                </h5>

                <div class="history-meta">
                  <span v-if="item.tooth">
                    Tooth: <strong>{{ item.tooth }}</strong>
                  </span>
                  <span v-if="item.clinician">
                    Clinician: <strong>{{ item.clinician }}</strong>
                  </span>
                </div>

                <p class="history-notes">
                  {{ item.notes }}
                </p>

                <div class="history-actions">
                  <button class="btn btn-sm btn-light me-2">
                    <i class="fas fa-eye"></i> View
                  </button>
                  <button class="btn btn-sm btn-light">
                    <i class="fas fa-edit"></i> Edit
                  </button>
                </div>
              </div>
            </div>

            <div
              v-if="history.length === 0"
              class="text-center text-muted py-5"
            >
              No dental history recorded for this patient
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import full_dental_head from "./full_eye_head.vue";
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "PatientDentalHistory",
  components: {
    full_dental_head,
  },
  data() {
    return {
      visit_id: this.$route.params.visit_id,
      history: [
        {
          id: 1,
          date: "2026-01-10",
          title: "Initial Dental Examination",
          tooth: null,
          clinician: "Dr. A. Mwangi",
          notes:
            "Patient presented with complaints of intermittent pain in the lower right quadrant. General oral hygiene fair. Plaque accumulation noted.",
        },
        {
          id: 2,
          date: "2026-01-12",
          title: "Diagnosis of Irreversible Pulpitis",
          tooth: "45",
          clinician: "Dr. A. Mwangi",
          notes:
            "Clinical tests and radiographic findings consistent with irreversible pulpitis. Treatment options discussed with patient.",
        },
        {
          id: 3,
          date: "2026-01-14",
          title: "Root Canal Treatment Completed",
          tooth: "45",
          clinician: "Dr. J. Otieno",
          notes:
            "RCT completed successfully under rubber dam isolation. Patient tolerated procedure well. Post-operative instructions given.",
        },
      ],
    };
  },
  methods: {
    openAddHistoryModal() {
      // Modal will be added later
    },
    async getClinicHistory() {
      const url = "getPatientClinicHistory";
      const res = await generalApiRequest(
        url,
        "GET",
        { visit_id: this.visit_id },
        1
      );
      this.history = res.data;
    },
  },
  mounted() {
    this.getClinicHistory();
  },
};
</script>

<style scoped>
/* Card */
.history-card {
  margin-top: 20px;
  border-radius: 10px;
  border: 1px solid #dee2e6;
  background: #ffffff;
}

/* Header */
.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #dee2e6;
}

.history-header h3 {
  margin: 0;
  font-size: 20px;
  color: #343a40;
}

/* Body */
.history-body {
  padding: 30px;
}

/* Timeline */
.history-timeline {
  position: relative;
  padding-left: 30px;
}

.history-timeline::before {
  content: "";
  position: absolute;
  left: 8px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #dee2e6;
}

.history-item {
  display: flex;
  margin-bottom: 30px;
}

.timeline-marker {
  position: relative;
  width: 80px;
  flex-shrink: 0;
}

.timeline-marker::before {
  content: "";
  position: absolute;
  left: 0;
  top: 6px;
  width: 14px;
  height: 14px;
  background: #0d6efd;
  border-radius: 50%;
}

.timeline-marker .date {
  font-size: 0.75rem;
  color: #6c757d;
  margin-left: 20px;
}

/* Content */
.timeline-content {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px 20px;
  width: 100%;
}

.history-title {
  font-size: 1rem;
  margin-bottom: 6px;
  color: #212529;
}

.history-meta {
  font-size: 0.8rem;
  color: #495057;
  margin-bottom: 10px;
  display: flex;
  gap: 20px;
}

.history-notes {
  font-size: 0.9rem;
  color: #343a40;
  margin-bottom: 12px;
}

/* Actions */
.history-actions .btn-light {
  background: #ffffff;
  border: 1px solid #dee2e6;
}

.history-actions .btn-light:hover {
  background: #e9ecef;
}

/* Responsive */
@media (max-width: 768px) {
  .history-timeline {
    padding-left: 15px;
  }

  .timeline-marker {
    width: 60px;
  }

  .history-meta {
    flex-direction: column;
    gap: 4px;
  }
}
</style>
